import { IImpressionCalculation } from '@/Interfaces/Forecaster';
import { LOADING } from '@/constants/forecaster';
import { numberToUsFormat } from '@/helpers/valueFormatter/numberFormatter.helpers';
import type { ForecastMetric } from '@/types/Forecaster/ForecastMetric.types';

export const NO_VALUE = '—';

export const getForecastMetricValue = (loading: boolean, metric: ForecastMetric, forecast?: IImpressionCalculation) => {
  if (loading) {
    return LOADING;
  }
  if (!forecast) {
    return NO_VALUE;
  }
  return numberToUsFormat(forecast[metric]);
};
